<template>
  <div class="composition-page">
    <div class="chart-table-wrap px-0 pb-0">
      <div class="chart-wrap">
      <v-row>
        <v-col cols="12" md="6">
          <LiberatedGasPressureChart :data="getChartData" :loading="loading" />
        </v-col>
        <v-col cols="12" md="6">
          <LiberatedGasComponentChart :data="getChartData" :loading="loading" />
          </v-col>
        </v-row>
      </div>
 
        <div class="table-wrap" v-if="cvdComposition && cvdComposition.length > 0 && !loading">
          <div class="table-title-div" >
            <p class="table-title">Liberated Gas Compositions</p>
            <div class="csv-btn" @click="downloadTableCSV()">
              <v-img :src="documentDownload" alt="csv download"></v-img>
            </div>
          </div>
          <table class="data-table lib-table">
            <!-- <tr class="table-main-header">
              <td>Stage Test</td>
              <td v-for="component in uniqueStepNumber" :key="component">
                {{ component }}
              </td>
            </tr> -->
            <tr class="table-main-header">
              <td>Stage Test</td>
              <td v-for="component in uniqueTestStep" :key="component">
                {{ component }}
              </td>
            </tr>
            <tr class="table-sub-header">
              <td class="d-flex align-center img-td">
                <span class="mr-2">Pressure (psia) </span>
                <v-img :src="arrow_right" alt="Arrow" width="20" height="20" />
              </td>
              <td v-for="component in uniqueStepPressure" :key="component">
                {{ component }}
              </td>
            </tr>
            <tr class="table-meta-row">
              <td>Temperature (°F)</td>
              <td v-for="pressure in uniqueStepPressure" :key="pressure">
                {{ stepTemperaturesByPressure[pressure] }}
              </td>
            </tr>
            <tr class="component-td">
              <td class="d-flex align-center img-td">
                <span class="mr-2">Component</span>
                  </td>
              <td class="text-left" v-for="component in uniqueStepPressure" :key="component">
                {{ vaporComponentColumnLabel }}
              </td>
            </tr>
            <tbody>
              <tr v-for="component in sortedFluidComponents" :key="component">
                <td class="text-left">{{ component }}</td>
                <td class="text-left" v-for="(entry) in cvdComposition.filter(
                  (entry) => entry.fluidComponentReference === component
                )" :key="entry.stepPressure">
                  {{
                    formatFraction(entry.vapor_MoleFraction)
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-left">Total</td>
                <td class="text-left" v-for="pressure in uniqueStepPressure" :key="pressure">
                  {{ calculateSum(pressure) }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="liberated-bottom-table">
            <div class="table-title-div">
              <p class="table-title">Calculated properties of Total Sample @ Standard Conditions</p>
            </div>
            <table class="data-table data-table-liberated">
              <tr class="main-header">
                <td class="main-header-td">
                  <span class="mr-2">MW (g/mol)</span>
                </td>
                <td v-for="component in MW" :key="component">
                  {{ component }}
                </td>
              </tr>
              <tr class="main-header">
                <td class="main-header-td">
                  <span class="mr-2">Gravity (Air=1)</span>
                </td>
                <td v-for="component in Gravity" :key="component">
                  {{ component }}
                </td>
              </tr>
            </table>
          </div>

          <div class="liberated-bottom-table">
            <div class="table-title-div">
              <p class="table-title">Calculated properties of C7 @ Standard Conditions</p>
            </div>
            <table class="data-table data-table-liberated">
              <tr class="main-header">
                <td class="main-header-td">
                  <span class="mr-2">MW (g/mol)</span>
                </td>
                <td v-for="component in MW" :key="component">
                  {{ component }}
                </td>
              </tr>
              <tr class="main-header">
                <td class="main-header-td">
                  <span class="mr-2">Density (g/cc)</span>
                </td>
                <td v-for="component in Density" :key="component">
                  {{ component }}
                </td>
              </tr>
            </table>
          </div> -->
        </div>
        <div v-else-if="!loading && !cvdComposition" class="text-center pt-15">
      <h4>Table data is not available.</h4>
    </div>
    <div v-else-if="loading">
      <screen-loader></screen-loader>
    </div>
      </div>
    </div>
</template>

<script>
import LiberatedGasPressureChart from "./LiberatedGasPressureChart.vue";
import LiberatedGasComponentChart from "./LiberatedGasComponentChart.vue";
import axios from "axios";
import ScreenLoader from "../Loaders/ScreenLoader.vue";
import { getComponentOrder} from '../../../utils/cache';
import { getTenantPrefix } from "@/utils/tenant";
import { VAPOR_COMPONENT_MOLE_CSV_HEADER } from "@/utils/chartAxisUtils";

export default {
  name: "LiberatedGasComposition",
  components: {
    LiberatedGasComponentChart,
    LiberatedGasPressureChart,
    ScreenLoader,
  },
  data: () => ({
    cvdComposition: [],
    loading: true,
    documentDownload: require("../../../assets/Images/csv.svg"),
    sortedFluidComponents: []
  }),
  computed: {
    tenantId() {
      return getTenantPrefix() || "";
    },
    vaporComponentColumnLabel() {
      return VAPOR_COMPONENT_MOLE_CSV_HEADER;
    },
    uniqueTestStep() {
      if (!this.cvdComposition) {
        return;
      }
      return [
        ...new Set(
          this.cvdComposition.map((entry) => entry.testStep)
        ),
      ];
    },
    uniqueStepPressure() {
      if (!this.cvdComposition) {
        return;
      }
      return [
        ...new Set(this.cvdComposition.map((entry) => entry.stepPressure)),
      ];
    },
    stepTemperaturesByPressure() {
    if (!this.cvdComposition) {
      return [];
    }
    const temperatures = {};
    this.cvdComposition.forEach((entry) => {
      temperatures[entry.stepPressure] = entry.stepTemperature;
    });
    return temperatures;
  },
  uniqueStepNumber() {
      if (!this.cvdComposition) {
        return;
      }
      return [
        ...new Set(this.cvdComposition.map((entry) => entry.stepNumber)),
      ];
    },
    getChartData() {
      if (!this.cvdComposition) {
        return;
      }
      return this.cvdComposition.map((entry) => ({
        fluidComponentReference: entry.fluidComponentReference,
        stepPressure: entry.stepPressure,
        vaporMoleFraction: entry.vapor_MoleFraction,
      }));
    },
  },
  watch: {
    cvdComposition: {
      async handler(newVal) {
        if (newVal && newVal.length > 0) {
          const components = [...new Set(newVal.map((entry) => entry.fluidComponentReference))];
          const componentOrders = await Promise.all(
            components.map(async (component) => {
              try {
                const order = await getComponentOrder(component);
                return { component, order };
              } catch (error) {
                return { component, order: Infinity };
              }
            })
          );

          this.sortedFluidComponents = componentOrders
            .sort((a, b) => a.order - b.order)
            .map(item => item.component);
        } else {
          this.sortedFluidComponents = [];
        }
      },
      immediate: true
    }
  },

  methods: {
    calculateSum(stepPressure) {
      if (!this.cvdComposition) {
        return 0;
      }
      const filteredEntries = this.cvdComposition.filter(
        (entry) => entry.stepPressure === stepPressure
      );
      return filteredEntries.reduce((sum, entry) => {
        return (
          sum + (parseFloat(entry.vapor_MoleFraction || 0))
        );
      }, 0).toFixed(3);
    },
    onSelectSort() {
      this.getTableData();
    },
    formatFraction(value) {
    if (value === null || value === undefined) {
      return "-";
    }
    return value.toFixed(3);
  },
    getTableData() {
      var sampleId = this.$route.params.sampleId;
      var separatorId = this.$route.params.id;
      this.loading = true;
      axios
        .get(
          process.env.VUE_APP_API_URL +
          `public/api/samples/${sampleId}/separatortests/${separatorId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "X-TenantID": this.tenantId,
            },
          }
        )
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.cvdComposition = response.data.data.separatortest.separatorComposition;
            if (!this.cvdComposition) {
              return;
            }
        }
        else if (response && response.data && response.data.message) {
          console.error(response.data.message);
          }
        else {
      console.error("Error in fetching data");
    }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadTableCSV() {
  if (this.cvdComposition && this.cvdComposition.length > 0) {
    const fileName = 'Liberated_gas_compositions.csv';

    const headerRow1 = ['Pressure (psia)', ...this.uniqueStepPressure];
    const headerRow2 = ['Component', ...this.uniqueStepPressure.map(() => this.vaporComponentColumnLabel)];

    const csvRows = (this.sortedFluidComponents || []).map(component => {
      const row = [component];
      this.uniqueStepPressure.forEach(pressure => {
        const entry = this.cvdComposition.find(e => e.fluidComponentReference === component && e.stepPressure === pressure);
        const value = entry?.vapor_MoleFraction;
        row.push(this.formatFraction(value));
      });
      return row;
    });

    const csvContent = [
      headerRow1.join(','),
      headerRow2.join(','),
      ...csvRows.map(row => row.join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName); // Set filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('Your browser does not support downloading files programmatically. Please try a different browser.');
    }
  } else {
    console.error('No data available in the table to download.');
  }
},
  },
  mounted() {
    this.getTableData();
  },
};
</script>